export const SITE_VISIT_COUNT = "SITE_VISIT_COUNT";
export const PAYTM_AUTOPAY = "PAYTM_AUTOPAY";
export const HEADER_FOOTER_MIGRATION_MY_SAVED_PAYMENT = 'EXP_H_F_M_M_S_P';
export const HEADER_FOOTER_MIGRATION_PAYMENT_SUCCESS = 'EXP_H_F_M_P_S';
// export const W_OTP_VERIFIED = 'W_OTP_VERIFIED';
